<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-60 md-xsmall-size-60">
      <img style="margin-left: 35px; margin-top:450px;" src="@/assets/img/globe-text.png" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //
    }
  }
}
</script>

<style></style>
